import { gql } from '@apollo/client'

export const adminSendBillingReminder = gql`
  mutation adminSendBillingReminder($deviceId: ID!) {
    adminSendBillingReminder(input: { deviceId: $deviceId }) {
      success
      message
      recipients
    }
  }
`
